import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { founderAdminApi } from '@/lib/founderApi';
import { errMsg } from '@/lib/digitalApi';

export const FulfillmentIssues = ({ tick, onChanged }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { founderAdminApi.issues().then((r) => setItems(r.items)).catch(() => {}); }, [tick]);
  if (!items.length) return null;
  const retry = async (oid) => {
    try {
      const r = await founderAdminApi.retry(oid);
      toast[r.fulfillment_status === 'fulfilled' ? 'success' : 'error'](`Order ${r.status} · fulfillment ${r.fulfillment_status || 'pending'}`);
      onChanged();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-10 bg-red-50 border border-red-200 rounded-xl p-5" data-testid="fb-fulfillment-issues">
      <div className="text-[10px] tracking-[0.22em] uppercase text-red-800">Needs attention · fulfillment</div>
      <div className="mt-3 divide-y divide-red-200">
        {items.map((o) => (
          <div key={o.id} className="py-3 flex flex-wrap items-center justify-between gap-3 text-sm" data-testid={`fb-issue-${o.id}`}>
            <div>
              <div>{o.first_name} · {o.email}</div>
              <div className="text-xs text-red-800">Payment {o.status} · fulfillment {o.fulfillment_status || '—'}{o.fulfillment_error ? ` · ${o.fulfillment_error}` : ''}</div>
            </div>
            <button onClick={() => retry(o.id)} className="text-xs uppercase tracking-[0.14em] px-4 py-2 border border-[#111] rounded-full bg-white" data-testid={`fb-issue-retry-${o.id}`}>
              {o.status === 'pending' ? 'Check Payment with Stripe' : 'Retry Fulfillment'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
